<template>
    <Row style="height: 100%;width: 100%" type="flex" id="imgTools1">
        <Card style="margin: 0">
            <Row v-if="isFirst && caseInfo != null">
                <Col span="24">
                <span class="bold-label">疾病名称：</span>
                <span v-for="item in caseInfo['发育障碍']['answer']" v-if="item != '无'" style="margin-right: 8px">{{item}}</span>
                <!--<span v-for="item in caseInfo['过敏性疾病']['answer']" v-if="item != '无'" style="margin-right: 8px">{{item}}</span>-->
                <span v-for="item in caseInfo['免疫性疾病']['answer']" v-if="item != '无'" style="margin-right: 8px">{{item}}</span>
                <span v-for="item in caseInfo['胃肠道疾病']['answer']" v-if="item != '无'" style="margin-right: 8px">{{item}}</span>
                <span v-for="item in caseInfo['精神神经性疾病']['answer']" v-if="item != '无'" style="margin-right: 8px">{{item}}</span>
                <span v-for="item in caseInfo['抗生素相关副作用']['answer']" v-if="item != '无'" style="margin-right: 8px">{{item}}</span>
                </Col>
                <Col span="24">
                <span class="bold-label">病情描述：</span>
                患病
                <span v-if="caseInfo['本次患病多久了'] != null && caseInfo['本次患病多久了']['answer'] != ''"
                      style="margin-right: 8px">{{caseInfo['本次患病多久了']['answer']}}</span>
                <span v-if="caseInfo['本次咨询前是否到医院就诊过'] != null && caseInfo['本次咨询前是否到医院就诊过']['answer'] != '' &&
                        caseInfo['本次咨询前是否到医院就诊过']['answer'] != '否'" style="margin-right: 8px">{{caseInfo['本次咨询前是否到医院就诊过']['answer']}}</span>
                <span v-else-if="caseInfo['本次咨询前是否到医院就诊过'] != null && (caseInfo['本次咨询前是否到医院就诊过']['answer'] === '' ||
                        caseInfo['本次咨询前是否到医院就诊过']['answer'] === '否')" style="margin-right: 8px">未到医院就诊过</span>
                <span v-if="caseInfo['病史补充说明'] != null && caseInfo['病史补充说明']['answer'] != ''"
                      style="margin-right: 8px">{{caseInfo['病史补充说明']['answer']}}</span>
                <span v-if="caseInfo['有哪些胃肠道症状'] != null">
                    <span v-for="item in caseInfo['有哪些胃肠道症状']['answer']" v-if="item != '无'" style="margin-right: 8px">{{item}}</span>
                </span>
                <span v-if="caseInfo['进食量'] != null && caseInfo['进食量']['answer'] != ''" style="margin-right: 8px">{{caseInfo['进食量']['answer']}}进食</span>
                <span v-if="caseInfo['大便性状'] != null && caseInfo['大便性状']['answer'] != ''" style="margin-right: 8px">大便{{caseInfo['大便性状']['answer']}}</span>
                <span v-if="caseInfo.自我评价 != null && caseInfo.自我评价.answer != null">
                        <span v-for="item in Object.keys(caseInfo.自我评价.answer)" v-if="item != ''" style="margin-right: 8px">
                            {{item}}：{{caseInfo.自我评价.answer[item].rate}}分</span>
                </span>
                </Col>
                <Col span="24">
                <span class="bold-label">目前治疗：</span>
                <span v-if="caseInfo['目前治疗中的饮食干预'] != null">
                                禁食
                                <span v-if="caseInfo['目前治疗中的饮食干预']['answer'] != null && caseInfo['目前治疗中的饮食干预']['answer'].length > 0">
                                    <span v-for="item in caseInfo['目前治疗中的饮食干预']['answer']"
                                          v-if="item != null && item != '其它'" style="margin-right: 8px">{{item}}</span>
                                </span>
                                <span v-else-if="caseInfo['目前治疗中的饮食干预']['answer'] != '其它'"
                                      style="margin-right: 8px">
                                {{caseInfo['目前治疗中的饮食干预']['answer']}}</span>
                            </span>
                <span v-if="caseInfo['目前治疗中的药物'] != null">
                                    使用
                                <span v-if="caseInfo['目前治疗中的药物']['answer'] != null && caseInfo['目前治疗中的药物']['answer'].length > 0">
                                    <span v-for="item in caseInfo['目前治疗中的药物']['answer']"
                                          v-if="item != null && item != '无' && item != '其它'" style="margin-right: 8px">{{item}}</span>
                                </span>
                                <span v-else-if="caseInfo['目前治疗中的药物']['answer'] != '其它'"
                                      style="margin-right: 8px">
                                {{caseInfo['目前治疗中的药物']['answer']}}</span>
                            </span>
                <span v-if="caseInfo['目前治疗中的营养素'] != null">
                                    使用
                                <span v-if="caseInfo['目前治疗中的营养素']['answer'] != null && caseInfo['目前治疗中的营养素']['answer'].length > 0">
                                    <span v-for="item in caseInfo['目前治疗中的营养素']['answer']"
                                          v-if="item != null && item != '无' && item != '其它'" style="margin-right: 8px">{{item}}</span>
                                </span>
                                <span v-else-if="caseInfo['目前治疗中的营养素']['answer'] != '其它'"
                                      style="margin-right: 8px">
                                {{caseInfo['目前治疗中的营养素']['answer']}}</span>
                            </span>
                <span v-if="caseInfo['患者当前使用的药物'] != null && caseInfo['患者当前使用的药物']['answer'] != '无'"
                      style="margin-right: 8px">{{caseInfo['患者当前使用的药物']['answer']}}</span>
                </Col>
                <Col span="24">
                <span class="bold-label">辅助检测及检查：</span>
                <div class="group-row">
                    <div v-if="caseInfo['病情相关的检查结果']!= null">
                        <div v-for="(item, index) in caseInfo['病情相关的检查结果'].answer" >
                            <!--<img :data-original='`${item}`' :src="item" style="max-height: 120px;max-width: 100%;margin: 10px">-->
                            <img :data-original='`${item}`' :src="item" style="height: 20px;width: 20px;margin: 5px 10px">
                        </div>
                    </div>
                    <div v-if="caseInfo['处方/药盒照片'] != null">
                        <div v-for="(item, index) in caseInfo['处方/药盒照片'].answer">
                            <!--<img :data-original='`${item}`' :src="item" style="max-height: 120px;max-width: 100%;margin: 10px">-->
                            <img :data-original='`${item}`' :src="item" style="height: 20px;width: 20px;margin: 5px 10px">
                        </div>
                    </div>
                </div>
                </Col>
                <Col span="24">
                <span class="bold-label">既往史：</span>
                <span v-if="caseInfo['既往史'] != null">
                        <span v-for="item in caseInfo['既往史']['answer']" v-if="item != '无'" style="margin-right: 8px">{{item}}</span>
                    </span>
                </Col>
                <Col span="24">
                <span class="bold-label">过敏史：</span>
                <span v-if="caseInfo['药物过敏'] != null && caseInfo['药物过敏']['answer'] != '无'"
                      style="margin-right: 8px">{{caseInfo['药物过敏']['answer']}}</span>
                <div v-if="caseInfo['过敏性疾病及症状'] != null">
                    <span v-for="item in caseInfo['过敏性疾病及症状']['answer']" v-if="item != '无' && item != null" style="margin-right: 8px">{{item}}</span>
                </div>
                </Col>
            </Row>
            <Row v-if="!user.isFirst && followCaseInfo != null">
                <Col span="24">
                <span class="bold-label">近期病情变化：</span>
                <span v-if="followCaseInfo['近期病情变化'] != null && followCaseInfo['近期病情变化']['answer'] != ''"
                      style="margin-right: 8px">{{followCaseInfo['近期病情变化']['answer']}}</span>
                </Col>
                <Col span="24">
                <span class="bold-label">饮食干预是否严格：</span>
                <span v-if="followCaseInfo['饮食干预是否严格'] != null && followCaseInfo['饮食干预是否严格']['answer'] != ''"
                      style="margin-right: 8px">饮食干预{{followCaseInfo['饮食干预是否严格']['answer']}}</span>
                </Col>
                <Col span="24">
                <span class="bold-label">使用的营养素/药品：</span>
                <span v-if="followCaseInfo['使用的营养素/药品'] != null && followCaseInfo['使用的营养素/药品']['answer'] != ''"
                      style="margin-right: 8px">{{followCaseInfo['使用的营养素/药品']['answer']}}</span>
                </Col>
                <Col span="24">
                <span class="bold-label">辅助检测及检查：</span>
                <div class="group-row" v-if="followCaseInfo['如果有新的检查结果，请上传图片'] != null">
                    <div v-for="(item, index) in followCaseInfo['如果有新的检查结果，请上传图片'].answer">
                        <img :data-original='`${item}`' :src="item" style="height: 20px;width: 20px;margin: 5px 10px">
                    </div>
                </div>
                </Col>
                <Col span="24">
                <span class="bold-label">病情描述：</span>
                <span v-if="followCaseInfo['有哪些胃肠道症状'] != null">
                            <span v-for="item in followCaseInfo['有哪些胃肠道症状']['answer']" v-if="item != '无'" style="margin-right: 8px">{{item}}</span>
                        </span>
                <span v-if="followCaseInfo['进食量'] != null && followCaseInfo['进食量']['answer'] != ''" style="margin-right: 8px">{{followCaseInfo['进食量']['answer']}}进食</span>
                <span v-if="followCaseInfo['大便性状'] != null && followCaseInfo['大便性状']['answer'] != ''" style="margin-right: 8px">大便{{followCaseInfo['大便性状']['answer']}}</span>
                <span v-if="followCaseInfo.自我评价 != null && followCaseInfo.自我评价.answer != null">
                        <span v-for="item in Object.keys(followCaseInfo.自我评价.answer)" v-if="item != ''" style="margin-right: 8px">
                            {{item}}：{{followCaseInfo.自我评价.answer[item].rate}}分</span>
                </span>
                </Col>
                <Col span="24">
                <span class="bold-label">本次咨询需要解决的问题：</span>
                <span v-if="followCaseInfo['本次咨询需要解决的问题'] != null && followCaseInfo['本次咨询需要解决的问题']['answer'] != ''" style="margin-right: 8px">
                            {{followCaseInfo['本次咨询需要解决的问题']['answer']}}</span>
                </Col>
            </Row>
        </Card>
    </Row>

</template>
<script>
    import Viewer from 'viewerjs';
    import ICol from "../../../node_modules/iview/src/components/grid/col.vue";
    export default {
        components: {ICol},
        name: "patient_diagnose_new",
        props: {
            isFirst: {
                type: Boolean,
                default: true
            },
            medicalRecordId: {
                type: Number,
                default: null
            }
        },
        data() {
            return {
                wHeight: window.innerHeight - 50,
                user: null,
                caseInfo: null,
                caseData: null,
                firstQuestions: null,
                followQuestions: null,
                otherCaseData:null,
                followCaseInfo: null
            }
        },
        created() {
            this.user = this.$store.state.currentPatient
//            this.getUserCase()
//            this.getLatestCase()
            this.getUseMedicalRecord()
        },
        methods: {
            checkUser () {
                if (this.user == null || this.user.id == null){
                    this.$Notice.error({title: '请重新登录'})
                    this.$router.push('/')
                    return
                }
            },
            // 获取患者填写的病历详情
            getUseMedicalRecord() {
                this.checkUser()
                this.infoLoading = true
                this.$http.post('medicalRecord/getById', {
                    id: this.medicalRecordId
                }).then(function (res) {
                    let msg = res.body
                    if (msg.success) {
                        console.log(msg.data)
                        console.log('this.isFirst', this.isFirst)
                        if (msg.data != null && msg.data.result != null) {
                            // 如果是首诊，用caseData存储首诊的caseData，如果是随诊，用otherCaseData存储首诊的caseData
                            if (this.isFirst) {
                                this.caseData = msg.data
                                this.caseInfo = JSON.parse(this.caseData.result)
                                this.getfirstQuestion()
                            } else {
                                this.otherCaseData = msg.data
                                this.followCaseInfo = JSON.parse(this.otherCaseData.result)
                                this.getFollowQuestion()
                            }
                            setTimeout(() => {
                                this.initImageTools()
                            }, 200)
                        }
                    } else {
                        this.$Notice.error({title: '病历查询失败', desc: msg.message});
                    }
                }, function (res) {
                    this.infoLoading = false
                    this.myError(res.body)
                })
            },
            // 获取最近一条病历
            getUserCase() {
                this.checkUser()
                this.infoLoading = true
                this.$http.post('medicalRecord/getResult', {
                    userId: this.user.id,
                    isFirst: true,
                    pageSize: 1
                }).then(function (res) {
                    let msg = res.body
                    if (msg.success) {
                        if (msg.data.list != null && msg.data.list.length > 0) {
                            this.caseData = msg.data.list[0]
                            this.caseInfo = JSON.parse(this.caseData.result)
                            console.log(this.caseInfo)
                            // 如果是首诊，用caseData存储首诊的caseData，如果是随诊，用otherCaseData存储首诊的caseData
                            if (this.user.isFirst) {
                                this.caseData = msg.data.list[0]
                                this.caseInfo = JSON.parse(this.caseData.result)
                            } else {
                                this.otherCaseData = msg.data.list[0]
                                this.caseInfo = JSON.parse(this.otherCaseData.result)
                            }
                            this.getfirstQuestion()
                            setTimeout(() => {
                                this.initImageTools()
                            }, 200)
                        }
                    } else {
                        this.$Notice.error({title: '病历查询失败', desc: msg.message});
                    }
                }, function (res) {
                    this.infoLoading = false
                    this.myError(res.body)
                })
            },
            // 获取最近一条随诊病历
            getLatestCase() {
                this.checkUser()
                this.infoLoading = true
                this.$http.post('medicalRecord/getResult', {
                    userId: this.user.id,
                    isFirst: false,
                    pageSize: 1
                }).then(function (res) {
                    let msg = res.body
                    if (msg.success) {
                        if (msg.data.list != null && msg.data.list.length > 0) {
                            // 如果是首诊，用otherCaseData存储随诊的caseData，如果是随诊，用caseData存储随诊的caseData
                            if (this.user.isFirst) {
                                this.otherCaseData = msg.data.list[0]
                                this.followCaseInfo = JSON.parse(this.otherCaseData.result)
                            } else {
                                this.caseData = msg.data.list[0]
                                this.followCaseInfo = JSON.parse(this.caseData.result)
                            }
                            console.log('followCaseInfofollowCaseInfo', this.followCaseInfo)
                            this.getFollowQuestion()
                        }
                    } else {
                        this.$Notice.error({title: '病历查询失败', desc: msg.message});
                    }
                }, function (res) {
                    this.infoLoading = false
                    this.myError(res.body)
                })
            },
            // 获取首诊问题
            getfirstQuestion () {
                this.$http.get('medicalRecord/firstQuestion').then(function (res) {
                    let msg = res.body
                    if (msg.success) {
                        this.firstQuestions = msg.data
                        this.bindAnswerToQuestion(true)
                    } else {
                        this.$Notice.error({title: '病历查询失败', desc: msg.message});
                    }
                }, function (res) {
                    this.infoLoading = false
                    this.myError(res.body)
                })
            },
            // 获取随诊问题
            getFollowQuestion () {
                this.$http.get('medicalRecord/followQuestion').then(function (res) {
                    let msg = res.body
                    if (msg.success) {
                        this.followQuestions = msg.data
                        this.bindAnswerToQuestion(false)
                    } else {
                        this.$Notice.error({title: '病历查询失败', desc: msg.message});
                    }
                }, function (res) {
                    this.infoLoading = false
                    this.myError(res.body)
                })
            },
            // 把病历答案绑定回问题
            bindAnswerToQuestion (isFirst) {
                if (isFirst) {
                    this.firstQuestions.map(item => {
                        item.questions.map(question => {
                            if (this.caseInfo[question.question] != null) {
                                let temp = question
                                question['answer'] = JSON.parse(JSON.stringify(this.caseInfo[question.question]))
                                this.caseInfo[question.question] = temp
                                // 如果有选项，则看答案中是否有不在选项中的其它自定义输入内容
                                if (question.choice != null && question.choice.length > 0) {
                                    if (Array.isArray(question.answer)) {
                                        question.answer.map(ans => {
                                            if (question.choice.indexOf(ans) < 0){
                                                question.choice.push(ans)
                                            }
                                        })
                                    } else {
                                        if (question.choice.indexOf(question.answer) < 0){
                                            question.choice.push(question.answer)
                                        }
                                    }
                                }
                            }
                        })
                    })
                } else {
                    console.log('this.followQuestions', this.followQuestions)
                    if (this.followQuestions == null || this.followQuestions.length <= 0) {
                        return
                    }
                    this.followQuestions.map(item => {
                        item.questions.map(question => {
                            if (this.followCaseInfo != null && this.followCaseInfo[question.question] != null) {
                                let temp = question
                                question['answer'] = JSON.parse(JSON.stringify(this.followCaseInfo[question.question]))
                                this.followCaseInfo[question.question] = temp
                                console.log('question', question)
//                                // 如果有选项，则看答案中是否有不在选项中的其它自定义输入内容
                                if (question.choice != null && question.choice.length > 0) {
                                    if (Array.isArray(question.answer)) {
                                        question.answer.map(ans => {
                                            if (question.choice.indexOf(ans) < 0){
                                                question.choice.push(ans)
                                            }
                                        })
                                    } else {
                                        if (question.choice.indexOf(question.answer) < 0){
                                            question.choice.push(question.answer)
                                        }
                                    }
                                }
                            }
                        })
                    })
                }
                console.log('followCaseInfo', this.followCaseInfo)
            },
            initImageTools() {
                //初始化 viewerjs
                setTimeout(()=>{
                    this.ViewerDom = document.getElementById('imgTools');
                    const viewer = new Viewer(this.ViewerDom, {
                        url: "data-original",
                        show: function () {
                            viewer.update()
                        }
                    });
                }, 300)
            },
        }
    }
</script>

<style scoped>
    .bold-label{
        font-size: 15px;
        font-weight: bold;
    }
    .group-row {
        display: flex;
        flex-direction: row;
        width: 100%;
    }
</style>
